import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices } from '../../../../core/contexts/useServices';
import { CreateApiClientData } from '../../domain/models/ApiClient';

export const API_CLIENTS_QUERY_KEY = ['api-clients'] as const;
export const API_CLIENT_OPTIONS_QUERY_KEY = ['api-client-options'] as const;

export function useApiClients() {
  const { apiClientService } = useServices();
  return useQuery({
    queryKey: API_CLIENTS_QUERY_KEY,
    queryFn: () => apiClientService.getAll(),
  });
}

export function useApiClientOptions() {
  const { apiClientService } = useServices();
  return useQuery({
    queryKey: API_CLIENT_OPTIONS_QUERY_KEY,
    queryFn: () => apiClientService.getOptions(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useCreateApiClient() {
  const { apiClientService } = useServices();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateApiClientData) => apiClientService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: API_CLIENTS_QUERY_KEY });
    },
  });
}
